import { createClient, type SanityClient } from '@sanity/client';
import imageUrlBuilder from '@sanity/image-url';
import type { SanityImageSource } from '@sanity/image-url/lib/types/types';

const projectId = import.meta.env.VITE_SANITY_PROJECT_ID;
const dataset = import.meta.env.VITE_SANITY_DATASET;
const apiVersion = import.meta.env.VITE_SANITY_API_VERSION;

if (!projectId) {
  throw new Error(
    'VITE_SANITY_PROJECT_ID is not set. Add SANITY_PROJECT_ID to .env and restart the dev server.',
  );
}

// useCdn: false so new/edited content appears on the very next page load.
// The CDN can lag ~60s behind the live API, which made Andre's freshly
// published service sections look like they "weren't rendering".
export const sanityClient: SanityClient = createClient({
  projectId,
  dataset,
  apiVersion,
  useCdn: false,
  perspective: 'published',
});

const builder = imageUrlBuilder(sanityClient);

export function urlFor(source: SanityImageSource | undefined | null): string {
  if (!source) return '';
  return builder.image(source).auto('format').url();
}
